export default function isTesting(): boolean {
  return process.env.NODE_ENV === 'development';
}
